<template>
    <ReportContainer>
      <template #filter>
        <b-form-group
          label="Contract">
          <!-- <v-select
            :options="options.contracts.items"
            :filterBy="filterContract"
            label="contractNo"
            v-model="filters.ledger.contractId"
            :reduce="contract => contract.id"
            :selectable="option => option.contractStatusId === $options.ContractStatuses.APPROVED.id"
            :loading="options.contracts.isBusy">
            <template #spinner="{ loading }">
              <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
            </template>
            <template #option="option">
              <ContractOptionItem noStatus :contract="option"/>
            </template>
          </v-select> -->

          <div style="display: flex;">
            <b-input  disabled :value="selectedContract?.contractNo"></b-input>
            <b-btn class="ml-1" variant="primary" size="sm"  @click="showContracts()">Select</b-btn>
          </div>
        </b-form-group>

        <b-form-group>
          <label> Trade Name</label>
          <b-form-input
            :value="selectedContract?.tradeName"
            disabled/>
        </b-form-group>
        <b-form-group
          label="As of Date">
          <b-form-datepicker  v-model="filters.ledger.asOfDate"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-form-radio-group
          class="mb-3"
          v-model="viewType"
          name="radio-sub-component">
          <b-form-radio value="Report">Report</b-form-radio>
          <b-form-radio value="Table">Table</b-form-radio>
        </b-form-radio-group>
        <b-button variant="outline-primary" @click="onPreview">Preview</b-button>
        <b-button class="mt-2" variant="outline-danger" @click="onClear">Clear</b-button>
      </template>
      <template #content>
        <ReportViewer v-if="viewType ==='Report'" :reportSource="file.src" :isLoading="file.isLoading"/>
        
        <div v-if="viewType ==='Table' && filters.ledger.contractId" class="table__container">
          <div class="mb-3 table__title">
            Transactions
          </div>
          <b-row>
            <b-col md="6">
              Client : {{ selectedContract && selectedContract.client.name }}
            </b-col>
            <b-col md="6">
              Tin : {{ selectedContract && selectedContract.tin }}
            </b-col>
            
          </b-row>

          <b-row class="mt-1 mb-3">
            <b-col md="6">
              Contract No: {{ selectedContract && selectedContract.contractNo }}
            </b-col>
            <b-col md="6">
              Tradename: {{ selectedContract && selectedContract.tradeName }}
            </b-col>
            
          </b-row>

          <CustomTable
            :table="tables.transactions"
          >
            <template v-slot:cell(balance)="{ index }">
              {{ getRunningBalance(index) }}
            </template>

            <template v-slot:cell(referenceNo)="data">
              <b-link @click="onToggleDetails(data)">{{ data.item.referenceNo }}</b-link>
            </template>


            <template #row-details="data">
              <div v-if="data.item.isBilling">
                <BillingRowDetail :billing="data.item" :loading="data.item.isLoading" />
              </div>
              <div v-else> 
                <PaymentRowDetail :payment="data.item" :loading="data.item.isLoading" />
              </div>
            </template>
          </CustomTable>
        </div>
        <ContractsModal
        :params="{ }"
        @clickContract="onSelectContract($event.id)"
        @close="showContractsModal = false"
        :show="showContractsModal"/>
       
      </template>

       
    </ReportContainer>

    
</template>

<script>
import { ReportApi, ContractApi, BillingApi, PaymentApi } from '../../mixins/api'
import { ContractStatuses } from '../../helpers/enum'
import ReportContainer from '../components/ReportContainer'
import ReportViewer from '../components/ReportViewer'
import ContractOptionItem from '../components/ContractOptionItem'
import { showNotification, formatNumber } from '../../helpers/forms'
import CustomTable from '../components/CustomTable.vue'
import { copyValue } from '../../helpers/extractor'

import BillingRowDetail  from '../components/BillingRowDetail.vue'
import PaymentRowDetail from '../components/PaymentRowDetail.vue'
import ContractsModal from '../components/ContractsModal.vue'

export default {
  components: {
    ReportContainer,
    ReportViewer,
    ContractOptionItem,
    CustomTable,
    BillingRowDetail,
    PaymentRowDetail,
    ContractsModal
  },
  mixins: [ ReportApi, ContractApi, BillingApi, PaymentApi ],
  ContractStatuses,
  data() {
    return {
      isLoading: false,
      viewType: 'Report',
      selectedContract: null,
      showContractsModal: false,
      filters:{ 
        ledger: {
          contractId: null,
          asOfDate: new Date
        }
      },
      options: {
        contracts: {
          isBusy: false,
          items: []
        }
      },
      file: {
        src: '',
        isLoading: false
      },
      tables: {
        transactions: {
          fields: [
            {
              key: 'referenceDate',
              label: 'DATE',
              thClass: 'align-middle',
              thStyle: { width: '20%' },
            },
            {
              key: 'referenceNo',
              label: 'REFERENCE',
              thClass: 'align-middle',
              thStyle: { width: '20%' },
            },
            {
              key: 'amount',
              label: 'BILLING',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '20%' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'paymentAmount',
              label: 'COLLECTION',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '20%' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'balance',
              label: 'BALANCE',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '20%' }
            },
          ],
          items: []
        }
      }
    }
  },
  created() {
    this.loadContracts()
  },
  methods: {
    showContracts() {
      this.showContractsModal = true
    },
     onSelectContract(id) {
      if (!id) {
        return
      }

      this.getContract(id).then(( { data }) => {
        this.showContractsModal = false
        this.selectedContract = data
        this.filters.ledger.contractId = data.id
      })
    },
    onClear() {
      this.selectedContract = null
      this.filters.ledger.contractId = null
      this.file.src = ''
    },
    onPreviewLedger() {
      const { contractId, asOfDate } = this.filters.ledger
      if (!contractId) {
        showNotification(this, 'danger', 'Please select contract before preview.')
        return
      }
      this.file.src = ''
      this.file.isLoading = true
      const params = { contractId, asOfDate }
      this.previewClientSubsidiaryLedger(params).then(response  => {
        const file = new Blob([response.data], { type: "application/pdf" } )
          const reader = new FileReader();
          reader.onload = e => this.file.src = e.target.result
          reader.readAsDataURL(file);
          this.file.isLoading = false
      })
    },
    loadHistory() {
      const { contractId, asOfDate } = this.filters.ledger
      const { transactions } = this.tables

      if (!contractId) {
        showNotification(this, 'danger', 'Please select contract before preview.')
        return
      }
      const params = { contractId, asOfDate }

      this.getContractHistory(contractId, params)
      .then(({ data }) => {
        transactions.items = data
      })
    },
    loadContracts() {
      const { ContractStatuses } = this.$options
      const params = { paginate : false, contractStatusId: ContractStatuses.APPROVED.id  }
      const { contracts } = this.options 
      contracts.isBusy = true
      this.getContractList(params).then(({ data }) => {
        contracts.items = data
        contracts.isBusy = false
      }) 
    },
    filterContract(option, label, search) {
      let temp = search.toLowerCase();
      return option.contractNo?.toLowerCase().indexOf(temp) > -1 || 
      option.tradeName.toLowerCase().indexOf(temp) > -1
    },
    getRunningBalance(index) {
      const { items } = this.tables.transactions
      const balance = items.filter((i, idx) => idx <= index)?.reduce((total, i) => total += Number(i.amount) - Number(i.paymentAmount), 0)
      return formatNumber(balance)
    },
    onPreview() {
      this.onPreviewLedger()
      this.loadHistory()
    },
    async onToggleDetails(row) {
      
      if(!row.detailsShowing) {
        this.$set(row.item, 'isLoading', true)
        

        if(row.item.isBilling) {
          const billingId = row.item.id
          await this.getBilling(billingId).then(({ data }) => {
            copyValue(data, row.item)
            this.$set(row.item, 'charges', data.charges)
            this.$set(row.item, 'billingNo', data.billingNo)
            this.$set(row.item, 'client', data.client)
            this.$set(row.item, 'contract', data.contract)
            this.$set(row.item, 'billingDate', data.billingDate)
            this.$set(row.item, 'dueDate', data.dueDate)
            this.$set(row.item, 'adjustmentCharges', data.adjustmentCharges)
            // this.$set(row.item, 'bank', data.bank)
            this.$set(row.item, 'isLoading', false)
          })
        }
        else {
          
          const paymentId = row.item.id
          await this.getPayment(paymentId).then(({ data }) => {
            // copyValue(data, row.item)
            this.$set(row.item, 'charges', data.charges)
            this.$set(row.item, 'bank', data.bank)
            this.$set(row.item, 'eWallet', data.eWallet)
            this.$set(row.item, 'approvedByPersonnel', data.approvedByPersonnel)
            this.$set(row.item, 'client', data.client)
            this.$set(row.item, 'contract', data.contract)
            this.$set(row.item, 'paymentNo', data.paymentNo)
            this.$set(row.item, 'transactionNo', data.transactionNo)
            this.$set(row.item, 'transactionDate', data.transactionDate)
            this.$set(row.item, 'paymentTypeId', data.paymentTypeId)
            this.$set(row.item, 'paymentType', data.paymentType)
            this.$set(row.item, 'paymentStatusId', data.paymentStatusId)
            this.$set(row.item, 'amount', data.amount)
            this.$set(row.item, 'isLoading', false)
          })
        }
      }
      row.toggleDetails()
    },
  },
}
</script>

<style lang="scss" scoped>
  .ledger-detailed__container {
    height: 100%;
    width: 100%;
  }

  .table__container {
    padding: 20px;
  }

  .table__title {
    font-size: 14pt;
    font-weight: 600;
  }
</style>